import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Image from '@namia/image';
import Spacer from './Spacer';

const ProductHighlight = (props) => {
  const {
    image: {
      src,
      srcset,
      placeholder,
      placeholderBase64,
      base64,
      width,
      height,
      alt,
    },
    headline,
    body,
    link: { title, url, target },
  } = props;

  return (
    <div className="product-highlight">
      <Row>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          sm={{ offset: 0, span: 8 }}
        >
          <Image
            alt={alt}
            base64={base64}
            onError={() => {}}
            placeholder={placeholder}
            onLoad={() => {}}
            placeholderBase64={placeholderBase64}
            ratio={`${width}/${height}`}
            src={src}
            srcset={srcset}
          />
        </Col>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          sm={{ offset: 0, span: 16 }}
        >
          <div className="product-highlight__content">
            <div className="product-highligt__text">
              <h2 className="product-highlight__headline">{headline}</h2>
              <p className="product-highlight__body">{body}</p>
              <Spacer size="lg" />
            </div>
            <div className="product-highlight__cta">
              <div className="product-highlight__button">
                <a target={target} className="button large green" href={url}>
                  {title}
                </a>
              </div>
              <Spacer size="lg" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

ProductHighlight.propTypes = {
  image: PropTypes.shape({
    description: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    srcset: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    base64: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    fields: PropTypes.shape.isRequired,
    placeholderBase64: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  headline: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductHighlight;
